// Store-header stream KPIs (analyzed streams / fisheyes / unactive), computed
// from the camera-model tree. Replaces the legacy walk over
// video_recorders → channels → sub_channels in StoreDetailView; the legacy
// fisheye test (channel has sub_channels) maps to a camera having more than
// one view.

export function computeStreamKpisFromCameraTree(tree) {
  let analyzedStreams = 0;
  let analyzedFisheyes = 0;
  let unactiveStreams = 0;
  (tree || []).forEach((device) => {
    (device.cameras || []).forEach((camera) => {
      if (camera.is_active === false || camera.inference_machine == null) {
        unactiveStreams += 1;
        return;
      }
      if ((camera.views || []).length > 1) {
        analyzedFisheyes += 1;
      } else {
        analyzedStreams += 1;
      }
    });
  });
  return { analyzedStreams, analyzedFisheyes, unactiveStreams };
}

export function computeStreamKpisFromLegacyStore(store) {
  let analyzedStreams = 0;
  let analyzedFisheyes = 0;
  let unactiveStreams = 0;
  (store.video_recorders || []).forEach((videoRecorder) => {
    videoRecorder.channels.forEach((channel) => {
      if (!channel.is_active || !channel.inference_machine) {
        unactiveStreams += 1;
        return;
      }
      if (channel.sub_channels.length === 0) {
        analyzedStreams += 1;
      } else {
        analyzedFisheyes += 1;
      }
    });
  });
  return { analyzedStreams, analyzedFisheyes, unactiveStreams };
}
